import { render, staticRenderFns } from "./AcceptHostedButton.vue?vue&type=template&id=5f2e2e36&"
import script from "./AcceptHostedButton.vue?vue&type=script&lang=js&"
export * from "./AcceptHostedButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports